import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ConfigService } from './config.service';

export interface BusinessCapabilities {
  allows_dine_in: boolean;
  allows_takeaway: boolean;
  allows_delivery: boolean;
  reservation_enabled: boolean;
  business_type?: string;
}

export interface BusinessDetailApi {
  id: string;
  name: string;
  slug: string;
  logo_url?: string;
  cover_image_url?: string;
  description?: string;
  short_description?: string;
  phone?: string;
  whatsapp?: string;
  email?: string;
  website?: string;
  address?: string;
  city?: string;
  postal_code?: string;
  country: string;
  tags: string[];
  is_open: boolean;
  hours?: {
    monday?: { open: string; close: string; closed: boolean };
    tuesday?: { open: string; close: string; closed: boolean };
    wednesday?: { open: string; close: string; closed: boolean };
    thursday?: { open: string; close: string; closed: boolean };
    friday?: { open: string; close: string; closed: boolean };
    saturday?: { open: string; close: string; closed: boolean };
    sunday?: { open: string; close: string; closed: boolean };
  };
  allows_dine_in: boolean;
  allows_takeaway: boolean;
  allows_delivery: boolean;
  reservation_enabled: boolean;
  business_type?: string;
  booking_mode?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.baseUrl = this.config.getApiUrl();
  }

  getBusinessDetail(businessId: string): Observable<BusinessDetailApi> {
    return this.http.get<BusinessDetailApi>(
      `${this.baseUrl}/api/v1/businesses/${businessId}`
    );
  }

  searchBusinesses(query: string, filters: { dine_in?: boolean; takeaway?: boolean; delivery?: boolean; reservation?: boolean }): Observable<BusinessSearchResult[]> {
    let params = new HttpParams();
    if (query.trim()) {
      params = params.set('q', query.trim());
    }
    if (filters.dine_in) params = params.set('dine_in', 'true');
    if (filters.takeaway) params = params.set('takeaway', 'true');
    if (filters.delivery) params = params.set('delivery', 'true');
    if (filters.reservation) params = params.set('reservation', 'true');

    return this.http.get<{ success: boolean; data: BusinessSearchResult[] }>(
      `${this.baseUrl}/api/v1/public/businesses/search`, { params }
    ).pipe(map(res => res.data || []));
  }
}

export interface BusinessSearchResult {
  id: string;
  name: string;
  slug: string;
  address?: string;
  city?: string;
  logo_url?: string;
  short_description?: string;
  allows_dine_in: boolean;
  allows_takeaway: boolean;
  allows_delivery: boolean;
  accepts_reservations: boolean;
  business_type?: string;
  business_type_name?: string;
  booking_mode?: string;
  is_featured: boolean;
}
